import { Box } from '@mui/material';
import { StockItemFormDialog } from '../stock-item-form-dialog';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useRef } from 'react';
import BoxIcon from '@shared/components/BoxIcon';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';

export const StockShoppingListActions = (props: { id: string }) => {
  const { id } = props;
  const purchaseStockItemDialogRef = useRef<ImperativeFormDialogRefType | null>(null);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BoxIcon
          size="small"
          boxColor="#61fb0133"
          icon={<EditOutlinedIcon fontSize="small" color="success" />}
          onClick={() => purchaseStockItemDialogRef.current?.open()}
        />
      </Box>
      <StockItemFormDialog
        dialogRef={purchaseStockItemDialogRef}
        formUsagePurpose="purchase"
        defaultValues={{
          id,
        }}
      />
    </>
  );
};
